import React from "react";

// "Rexxpons" wordmark — network house style: clean bold sans, mixed case.
// The "xx" sits on the same baseline and size as the rest, styled as a
// cyan→blue gradient accent for a more graphic, premium look.
export const Wordmark = ({ className = "" }) => (
  <span className={`font-heading font-semibold tracking-tight ${className}`}>
    Re<span className="bg-gradient-to-br from-[#67e8f9] via-[#22d3ee] to-[#2563eb] bg-clip-text text-transparent">xx</span>pons
  </span>
);
